import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { apiRequest } from "../../utils/utils";

const ChangePassword = (props) => {
  console.log(props, 33543534523432);
  const { data } = props;

  const [newPassword, setNewPassword] = useState("");

  const passwordChangeSubmit = async () => {
    const postData = {
      // product_key: data && data.product_key,
      // customer_id: data && data.customer_id,
      studio_id: data && data.customer_id,
      user_id: data && data.customer_user_uuid,
      inputs: {
        new_password: newPassword,
      },
    };

    const responseData = await apiRequest(
      `${process.env.REACT_APP_CRM}/muvi5/change-password`,
      "POST",
      postData
    );

    if (responseData.code === 200) {
      props.close();
      props.syncFilterWithAggrid();
    }
  };

  const passwordHandler = (evt) => {
    const { name, value } = evt.target;

    setNewPassword(value);
  };

  return (
    <Modal show={props.show} onHide={props.close}>
      <Modal.Header>
        <Modal.Title>{data.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group">
          <label htmlFor="">New Password</label>
          <input
            type="password"
            name=""
            id=""
            className="form-control"
            onChange={passwordHandler}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button
            type="button"
            variant="dark"
            className="btn-dark-btn"
            onClick={props.close}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => passwordChangeSubmit()}
          >
            Save Changes
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/childcomponents/ChangePassword.js